module.exports = __webpack_public_path__ + "pc-top-assets/img/facebook.5141b681.png";